import { Pipe, PipeTransform } from '@angular/core'
import { formatPhoneNumber } from '@mmx/shared'

@Pipe({ name: 'phone', standalone: false })
export class PhonePipe implements PipeTransform {
  transform(phoneNumber: string) {
    return formatPhoneNumber(phoneNumber)
  }
}
